"use strict";

exports.__esModule = true;
exports["default"] = Filter;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Filter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M511 91.562c0-32.566-114.164-62.228-255-62.228S1 58.995 1 91.562c0 2.74.887 5.438 2.437 8.066H3.38l.304.498.721 1.051 204.779 267.381v93.715h.055c0 11.262 20.973 20.393 46.816 20.393 25.842 0 46.816-9.131 46.816-20.393 0-.139-.056-.332-.056-.469v-93.275l204.781-267.352.69-1.051.332-.498h-.057C510.113 97 511 94.302 511 91.562zm-255 51.105c-106.5 0-195.013-14.997-213.496-34.808-2.323-2.49-3.624-5.049-3.624-7.664 0-23.491 97.229-42.527 217.12-42.527s217.121 19.022 217.121 42.5c0 2.629-1.3 5.174-3.625 7.664C451.013 127.67 362.499 142.667 256 142.667z"
  }));
}